import React, { createContext, useContext, useState } from "react";
import Axios from "axios";

const BarcodeEntryContext = createContext();

export const useBarcodeEntryContext = () => useContext(BarcodeEntryContext);

export const BarcodeEntryProvider = ({ children }) => {
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // ✅ إضافة إدخال باركود مباشرة
  const addBarcodeEntry = async (product_id, barcode) => {
    try {
      console.log(product_id, barcode);

      const res = await Axios.post(
        `${process.env.REACT_APP_API_URL}/barcodeEntry/addBarcodeEntry.php`,
        { product_id, barcode },
        {
          headers: { "Content-Type": "application/json" },
          withCredentials: true,
        }
      );
      console.log(res);

      if (res.data?.status === "success") {
        return { success: true, data: res.data };
      } else {
        return { success: false, message: res.data?.message };
      }
    } catch (err) {
      return { success: false, message: err.response?.data?.message || "خطأ" };
    }
  };

  // ✅ جلب جميع الإدخالات
  const getBarcodeEntries = async () => {
    setLoading(true);
    setError("");

    try {
      const res = await Axios.get(
        `${process.env.REACT_APP_API_URL}/barcodeEntry/getBarcodeEntries.php`,
        { withCredentials: true }
      );
      console.log(res);

      if (res.data?.status === "success") {
        setEntries(res.data.entries);
        setLoading(false);
        return { success: true, data: res.data.entries };
      } else {
        const msg = res.data?.message || "فشل في جلب الإدخالات";
        setError(msg);
        setLoading(false);
        return { success: false, message: msg };
      }
    } catch (err) {
      const msg = err.response?.data?.message || "خطأ في الاتصال";
      setError(msg);
      setLoading(false);
      return { success: false, message: msg };
    }
  };

  // ✅ تحديث الكمية
  const updateBarcodeQuantity = async (id, quantity) => {
    try {
      const res = await Axios.post(
        `${process.env.REACT_APP_API_URL}/barcodeEntry/updateBarcodeQuantity.php`,
        { id, quantity },
        {
          headers: { "Content-Type": "application/json" },
          withCredentials: true,
        }
      );

      if (res.data?.status === "success") {
        return { success: true };
      } else {
        return { success: false, message: res.data?.message };
      }
    } catch (err) {
      return { success: false, message: err.response?.data?.message || "خطأ" };
    }
  };

  // ✅ حذف إدخال
  const deleteBarcodeEntry = async (id) => {
    try {
      const res = await Axios.post(
        `${process.env.REACT_APP_API_URL}/barcodeEntry/deleteBarcodeEntry.php`,
        { id },
        {
          headers: { "Content-Type": "application/json" },
          withCredentials: true,
        }
      );

      if (res.data?.status === "success") {
        return { success: true };
      } else {
        return { success: false, message: res.data?.message };
      }
    } catch (err) {
      return { success: false, message: err.response?.data?.message || "خطأ" };
    }
  };

  // ✅ مسح جميع الإدخالات
  const clearAllEntries = async () => {
    try {
      const res = await Axios.post(
        `${process.env.REACT_APP_API_URL}/barcodeEntry/clearAllEntries.php`,
        {},
        {
          headers: { "Content-Type": "application/json" },
          withCredentials: true,
        }
      );

      if (res.data?.status === "success") {
        return { success: true };
      } else {
        return { success: false, message: res.data?.message };
      }
    } catch (err) {
      return { success: false, message: err.response?.data?.message || "خطأ" };
    }
  };

  // ✅ تأكيد الإدخالات (إضافة للمخزون وحذف من جدول الباركود)
  const confirmEntries = async (shelf_ids = []) => {
    setLoading(true);
    setError("");

    try {
      const res = await Axios.post(
        `${process.env.REACT_APP_API_URL}/barcodeEntry/confirmEntries.php`,
        { shelf_ids },
        {
          headers: { "Content-Type": "application/json" },
          withCredentials: true,
        }
      );

      if (res.data?.status === "success") {
        setLoading(false);
        return {
          success: true,
          data: res.data,
          message: res.data.message,
        };
      } else {
        const msg = res.data?.message || "فشل في تأكيد الإدخالات";
        setError(msg);
        setLoading(false);
        return { success: false, message: msg };
      }
    } catch (err) {
      const msg = err.response?.data?.message || "خطأ في الاتصال";
      setError(msg);
      setLoading(false);
      return { success: false, message: msg };
    }
  };

  return (
    <BarcodeEntryContext.Provider
      value={{
        addBarcodeEntry,
        getBarcodeEntries,
        updateBarcodeQuantity,
        deleteBarcodeEntry,
        clearAllEntries,
        confirmEntries,
        entries,
        loading,
        error,
      }}
    >
      {children}
    </BarcodeEntryContext.Provider>
  );
};
